/**
 * Mega Menu Progressive - Gestion des interactions avec slide down
 */
document.addEventListener('DOMContentLoaded', function() {
  const megaMenus = document.querySelectorAll('.mega-menu-progressive');
  
  megaMenus.forEach(function(megaMenu) {
    const horizontalItems = megaMenu.querySelectorAll('.menu-item-horizontal');
    const submenuContents = megaMenu.querySelectorAll('.submenu-content');
    const parentMenuItem = megaMenu.closest('.menu__item');
    
    // Masquer tous les sous-menus au départ
    submenuContents.forEach(function(content) {
      content.style.display = 'none';
    });
    
    // Fonction pour ouvrir le mega menu avec slide down
    function openMegaMenu() {
      megaMenu.classList.add('open');
      // Ajouter classe active au lien principal
      if (parentMenuItem) {
        const mainLink = parentMenuItem.querySelector('[data-top-link]');
        if (mainLink) {
          mainLink.classList.add('active');
        }
      }
    }
    
    // Fonction pour fermer le mega menu avec slide up
    function closeMegaMenu() {
      megaMenu.classList.remove('open');
      // Retirer classe active du lien principal
      if (parentMenuItem) {
        const mainLink = parentMenuItem.querySelector('[data-top-link]');
        if (mainLink) {
          mainLink.classList.remove('active');
        }
      }
      // Masquer tous les sous-menus et retirer classes actives
      submenuContents.forEach(function(content) {
        content.style.display = 'none';
        content.classList.remove('active');
      });
      // Retirer classes actives des liens horizontaux
      horizontalItems.forEach(function(item) {
        const link = item.querySelector('.level-1-link-horizontal');
        if (link) {
          link.classList.remove('active');
        }
      });
    }
    
    // Événement d'entrée sur le lien principal (BOUTIQUE, etc.)
    if (parentMenuItem) {
      const mainLink = parentMenuItem.querySelector('[data-top-link]');
      if (mainLink) {
        mainLink.addEventListener('mouseenter', function() {
          openMegaMenu();
        });
      }
      
      // Événement de sortie du menu item entier
      parentMenuItem.addEventListener('mouseleave', function() {
        closeMegaMenu();
      });
    }
    
    // Ajouter les événements de survol pour les sous-menus
    horizontalItems.forEach(function(item, index) {
      const triggerIndex = item.getAttribute('data-submenu-trigger');
      const link = item.querySelector('.level-1-link-horizontal');
      
      item.addEventListener('mouseenter', function() {
        // S'assurer que le mega menu est ouvert
        openMegaMenu();
        
        // Retirer classe active de tous les liens horizontaux
        horizontalItems.forEach(function(otherItem) {
          const otherLink = otherItem.querySelector('.level-1-link-horizontal');
          if (otherLink) {
            otherLink.classList.remove('active');
          }
        });
        
        // Ajouter classe active au lien courant
        if (link) {
          link.classList.add('active');
        }
        
        // Masquer tous les sous-menus
        submenuContents.forEach(function(content) {
          content.style.display = 'none';
          content.classList.remove('active');
        });
        
        // Afficher le sous-menu correspondant avec animation
        const targetSubmenu = megaMenu.querySelector(`[data-submenu-content="${triggerIndex}"]`);
        if (targetSubmenu) {
          targetSubmenu.style.display = 'block';
          // Petit délai pour permettre l'animation
          setTimeout(function() {
            targetSubmenu.classList.add('active');
          }, 10);
        }
      });
    });
    
    // Maintenir l'affichage quand on survole le contenu du sous-menu
    submenuContents.forEach(function(content) {
      content.addEventListener('mouseenter', function() {
        content.style.display = 'block';
        content.classList.add('active');
      });
    });
  });
});